import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Form, FormItem } from '@/components';
import { Link } from 'react-router-dom';
import { Button, Select } from '@/ui';
import { ChevronIcon } from '@/icons';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 2rem;
`;

export const StyledInputWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
`;

export const StyledUploadContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.5rem;
  border: 1px dashed ${COLORS.IRON_GRAY};
  border-radius: 0.5rem;
  background-color: ${COLORS.GRAY};
  word-break: break-all;
  transition: border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
  ${pickThemeFontStyles('14', '18')};

  svg {
    margin-right: 0.5rem;
  }
`;

export const StyledButtonsWrap = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledButtonBlocksWrap = styled.div`
  display: flex;
  width: 90%;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-end;
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background: ${COLORS.WHITE};
`;

export const StyledStockWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  flex-direction: row;
  background: ${COLORS.WHITE};
`;

export const StyledImportForm = styled(Form)`
  display: flex;
  width: 100%;
  max-width: 40rem;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 6rem;
  align-items: flex-start;
`;

export const StyledUploadingBox = styled.div`
  display: flex;
  width: 100%;
  max-width: 26.5rem;
  flex-direction: column;
  flex: 1;
  gap: 2rem;
  background: ${COLORS.GRAY_94};
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;

  ${pickThemeFontStyles('20', '32')};
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1;
  justify-content: space-between;
`;

export const StyledContinueBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  background-color: ${COLORS.GRAY};
  border-radius: 0.5rem;
  align-items: flex-start;
`;

export const StyledSelectWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledRow = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
  align-items: center;
  text-align: left;
`;

export const StyledFormItem = styled(FormItem)`
  width: 100%;
  text-align: left;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  svg {
    margin-right: 0.5rem;
  }
`;

export const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  aspect-ratio: 1;
  background: ${COLORS.WHITE};
  color: ${COLORS.BLACK};
  border: 1px solid ${COLORS.YELLOW_PRIMARY};
  ${pickThemeFontStyles('14', '18')};
  padding: 1rem;
`;

export const StyledLink = styled(Link)`
  ${pickThemeFontStyles('14', '18')};
  color: ${COLORS.NORMAL_GRAY};
  text-decoration: underline;
`;

export const StyledTitleAndLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.375rem;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
`;

export const StyledStepTitle = styled.div`
  ${pickThemeFontStyles('20', '30', 'NORMAL')};
  color: ${COLORS.BLACK};
  text-transform: uppercase;
`;

export const StyledChevronIcon = styled(ChevronIcon)`
  width: 1.25rem;
  fill: ${COLORS.CHARCOAL};
  transform: rotate(90deg);
`;

export const StyledBackButton = styled.div`
  ${pickThemeFontStyles('16', '20', 'NORMAL')};
  color: ${COLORS.CHARCOAL};
  gap: 0.5rem;
  display: flex;
  cursor: pointer;
  text-transform: uppercase;
  align-items: center;
`;

export const StyledLabel = styled.div<{ $bold?: boolean }>`
  ${({ $bold }) => pickThemeFontStyles('14', '22', $bold ? 'SEMI_BOLD' : 'NORMAL')};
  color: ${COLORS.BLACK};
`;

export const StyledSelect = styled(Select)`
  &&& {
    height: auto;
  }
`;
export const StyledDescription = styled.div`
  ${pickThemeFontStyles('12', '22', 'NORMAL')};
  color: ${COLORS.IRON_GRAY};
  text-align: left;
`;

export const StyledForm = styled(Form)`
  width: 100%;
`;
